import { render, staticRenderFns } from "./CollectionHistory.vue?vue&type=template&id=9e476736&scoped=true&"
import script from "./CollectionHistory.vue?vue&type=script&lang=ts&"
export * from "./CollectionHistory.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionHistory.vue?vue&type=style&index=0&id=9e476736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e476736",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
